import { AuthHandler } from './auth';
const _authHandler = new AuthHandler();

export const setAuthHandler = (authHandler: AuthHandler) => {
  authHandler = authHandler;
};

export default _authHandler;
